export enum PatientGender {
  FEMALE = 'FEMALE',
  MALE = 'MALE',
  DIVERS = 'DIVERS'
}